import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { ExpandableTabsDefaultProps, ExpandableTabsPropTypes } from 'src/components/JobDatasheet/propTypes';
import JobFormCountDown from 'src/components/JobFormCountDown';
import s from 'src/components/JobDatasheet/JobDatasheetForm/JobDatasheetForm.styles';

export const ExpandableTabs = ({
  disableReviewNotesButton,
  disableMoreInfoButton,
  retryAutoSave,
  retrying,
  saveFailedQuestions,
  setIsInfoCollapsed,
  setShowHistory,
  setShowNote,
  setShowResult,
}) => {
  const { i18n, t } = useTranslation();

  return (
    <Fragment>
      <s.CollapsedBtn
        first
        isDisabled={disableReviewNotesButton}
        lang={i18n.language}
        onClick={() => {
          if (disableReviewNotesButton) {
            return;
          }
          setShowResult(false);
          setShowNote(true);
          setShowHistory(false);
          setIsInfoCollapsed(false);
        }}
      >
        {t('REVIEW_NOTES')}
      </s.CollapsedBtn>
      <s.CollapsedBtn
        isDisabled={disableMoreInfoButton}
        lang={i18n.language}
        onClick={() => {
          if (disableMoreInfoButton) {
            return;
          }
          setShowResult(true);
          setShowNote(false);
          setShowHistory(false);
          setIsInfoCollapsed(false);
        }}
        second
      >
        {t('MORE_INFO')}
      </s.CollapsedBtn>
      {saveFailedQuestions && saveFailedQuestions.length > 0 &&
      !retrying &&
      <s.PopupWrapper>
        <JobFormCountDown
          className="link"
          inProgressTitle={'AutoSave in'}
          onClick={() => retryAutoSave(saveFailedQuestions)}
          time={30}
          title={'AutoSaving'}
        />
      </s.PopupWrapper>}
    </Fragment>
  );
};

ExpandableTabs.propTypes = ExpandableTabsPropTypes;

ExpandableTabs.defaultProps = ExpandableTabsDefaultProps;
